angular.module('lsnBase.availability', []);